module.exports = __webpack_public_path__ + "img/introduction-img@320w.66da2ae0.png";